export const translatePaymentMethod = (paymentMethod) => {
  const paymentMethodName = {
    bank_slip: 'boleto',
    credit_card: 'cartão à vista'
  }

  return paymentMethodName[paymentMethod] || paymentMethod
}
